export const DRAWER_WIDTH = 240;
export const V2_ICON_COLOR = '#00ACC1';

export const ROLES = {
  HYPER: 'hyper_admin',
  SUPER: 'super_admin',
  ADMIN: 'admin',
  USER: 'student',
  TRAINER: 'trainer',
};

export const BASE_USER_URL = '/';

export const ROUTES = {
  COMPANIES: 'companies',
  DASHBOARD: 'dashboard',
  NOTIFICATIONS: 'notifications',
  ADMINISTRATORS: 'administrators',
  TRAINERS: 'trainers',
  TASKS: 'tasks',
  TEMPLATES: 'templates',
  STATISTICS: 'statistics',
  SCHEDULE: 'schedule',
  PROFILE: 'profile',
};

export const STATISTIC_BY_EXPIRE_DATE_COLORS = {
  not_specified: '#6F7C8A',
  expired: '#F04632',
  '1_week': '#FAC733',
  '1_month': '#0519E0',
  '3_month': '#876DA7',
  up_to_date: '#32AE88',
};

export const COMPLIANCE_STATUS_COLORS = {
  incomplete: '#F04632',
  valid: '#1BA223',
  expired: '#FFA421',
  expiring_soon: '#F5FF00',
};

export const SATISFACTION_STATUS_COLORS = {
  satisfied: '#32AE88',
  unsatisfied: '#F04632',
};

export const JOB_TASKS_STATUSES = {
  mixed: 'Mixed',
  performed: 'Performed',
  notPerformed: 'Not Performed',
};
